var common = require("../../utiles/common.js");
var service = require("../../utiles/service");
var layUtils = require("../../utiles/layUtils");
var metaUtils = require("../../utiles/metaTypeUtils");
var columns = require("./ClientCol");
var metaService = require("../../services/metaService.js");

module.exports = {
  register: function () {
    document.createElement("client-list");
    ko.components.register("client-list", {
      viewModel: function (params) {
        var $this = this;
        $this.user = common.getStorage().user;
        console.log($this.user);

        $this.renderAttr = function (attr, data) {
          var setter = metaUtils.getAddon(
            metaUtils.metaType.QNAME_ATTRIBUTE_ADDON_SETTER,
            attr.addons
          );
          return metaUtils.getValue(attr, data, setter);
        };

        $this.renderList = function (dataTypeQualifyName, id, cols) {
          layUtils.table({
            elem: "#" + id,
            height: 600,
            url: "/auth/dataSearch/queryManageViewData",
            method: "post",
            where: {
              dataTypeQualifyName: dataTypeQualifyName,
              condition: {
                userName: $this.user.individualUserName,
              },
              sort: [
                {
                  attributeCode: "createdDate",
                  type: "DESC",
                },
              ],
            },
            page: true,
            cols: cols,
          });
        };

        layui.use(["form", "table"], function () {
          // 自动化加载
          var form = layui.form;
          var table = layui.table;
          table.on("tool(clientList1)", function (data) {
            console.log(data);
            var checkedText = data.data.safety
              ? "如果关闭，标识此客户端不安全，是否关闭?"
              : "如果开启，标识此客户端安全，是否开启？";
            layer.confirm(checkedText, { offset: "100px" }, function () {
              metaService.update({
                entity: { safety: !data.data.safety, id: data.data.id },
                qualifyName: metaUtils.metaType.QNAME_USER_SAFETY_DEVICE,
                ignoreEmpty: true,
              });
              setTimeout(function () {
                parent.layer.closeAll();
                $this.renderList(
                  metaUtils.metaType.QNAME_USER_SAFETY_DEVICE,
                  "clientList",
                  columns.ClientCol
                );
              }, 500);
            });
          });
          // form.on("switch(safety)", function (data) {
          //   console.log(data);
          //   var checkedText = data.elem.checked
          //     ? "如果开启，标识此客户端安全，是否开启？"
          //     : "如果关闭，标识此客户端不安全，是否关闭";
          //   layer.confirm(checkedText, { offset: "100px" }, function () {
          //     metaService.update({
          //       entity: { safety: data.elem.checked, id: data.elem.id },
          //       qualifyName: metaUtils.metaType.QNAME_USER_SAFETY_DEVICE,
          //       ignoreEmpty: true,
          //     });
          //     setTimeout(function () {
          //       parent.layer.closeAll();
          //       $this.renderList(
          //         metaUtils.metaType.QNAME_USER_SAFETY_DEVICE,
          //         "clientList",
          //         columns.ClientCol
          //       );
          //     }, 500);
          //   });
          // });
        });

        $this.renderList(
          metaUtils.metaType.QNAME_USER_SAFETY_DEVICE,
          "clientList",
          columns.ClientCol
        );
      },
      template: require("./Client.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/component/clientManager/Client.js
// module id = 208
// module chunks = 0